import { render, staticRenderFns } from "./deanHeaderMobile.vue?vue&type=template&id=2784833e&scoped=true"
import script from "./deanHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./deanHeaderMobile.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderMobile.vue?vue&type=style&index=0&id=2784833e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784833e",
  null
  
)

export default component.exports